"use client"
/* */
import { jsx } from 'react/jsx-runtime';
import 'react';
import clsx from 'clsx';
import styles from './MessageThread.module.scss.mjs';
import '../../lib/propsContext/propsContext.mjs';
import '../../lib/viewComponentContext/viewComponentContext.mjs';
import { dynamic } from '../../lib/propsContext/dynamicProps/dynamic.mjs';
import { PropsContextProvider } from '../../lib/propsContext/PropsContextProvider.mjs';
import { flowComponent } from '../../lib/componentFactory/flowComponent.mjs';

const MessageThread = flowComponent("MessageThread", (props) => {
  const { children, className } = props;
  const rootClassName = clsx(styles.messageThread, className);
  const propsContext = {
    Message: {
      className: dynamic((props2) => {
        return clsx(
          props2.className,
          styles.message,
          styles[props2.type ?? "responder"]
        );
      })
    }
  };
  return /* @__PURE__ */ jsx(PropsContextProvider, { props: propsContext, children: /* @__PURE__ */ jsx("div", { className: rootClassName, children }) });
});

export { MessageThread, MessageThread as default };
//# sourceMappingURL=MessageThread.mjs.map
